var dataModel = {
  1: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3433",

    prodName: "Captain Morgan sLICED APPLE Rum 70cl",
    prodImg: "products/prod-3.png",
    navBgColor: "#912b88",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
    carousel: true,
    carouselFull: true,

    carousel: true,
    carouselFull: true,
    carouselData: {
      1: {
        1: {
          title:
            "CAPTAIN MORGAN TIKI&nbsp;RUM FLAVOURED SPIRIT&nbsp;70CL - 25%ABV",
          img: "products/prod-2.png",
          url: "",
          dataAssetId: "2236",
        },
        2: {
          title:
            "CAPTAIN MORGAN TIKI&nbsp;RUM FLAVOURED SPIRIT&nbsp;70CL - 25%ABV",
          img: "products/prod-1.png",
          url: "",
          dataAssetId: "2236",
        },
        3: {
          title:
            "CAPTAIN MORGAN TIKI&nbsp;RUM FLAVOURED SPIRIT&nbsp;70CL - 25%ABV",
          img: "products/prod-3.png",
          url: "",
          dataAssetId: "2236",
        },
      },
    },
    hero: {
      video: {
        active: false,
        bgColor: "#58bbd0",
        gradLeft:
          "linear-gradient(90deg, rgba(88,107,208,1) 0%, rgba(88,107,208,0) 100%)",
        gradRight:
          "linear-gradient(-90deg, rgba(88,107,208,1) 0%, rga(88,107,208,0) 100%)",
      },
      bgImg: {
        bgColor: "#439aaf",
        gradLeft:
          "linear-gradient(90deg, rgba(67,154,175,1) 0%, rgba(67,154,175,0) 100%)",
        gradRight:
          "linear-gradient(-90deg, rgba(67,154,175,1) 0%, rgba(67,154,175,0) 100%)",
        maxWidth: "1400px",
      },
      serve_1: true,
      serve_2: true,
    },
    recipes: {
      1: {
        title: "Jam Daiquiri",
      },
      2: {
        title: "Captain and Cola ",
      },
      3: {
        title: "Captain and Lemonade",
      },
      4: {
        title: "Captain and Cola float",
      },
      5: {
        title: "test 5",
      },
      6: {
        title: "test 6",
      },
    },
    ui: {
      retailers: {
        1: {
          endpoint:
            "https://api.channelsight.com/api/2.0/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2803",
          title: '<div class="inline-nav__text">Spiced <br> Gold</div>',
          bgColor: "#1d98d5",
        },
        2: {
          endpoint:
            "https://api.channelsight.com/api/2.0/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2238",
          title: '<div class="inline-nav__text">Sliced <br> Apple</div>',
          bgColor: "#227b3c",
        },
        3: {
          endpoint:
            "https://api.channelsight.com/api/2.0/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2783",
          title: '<div class="inline-nav__text">Tiki</div>',
          bgColor: "#d4839a",
        },
        4: {
          endpoint:
            "https://api.channelsight.com/api/2.0/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2282",

          bgColor: "#922c88",
        },
        5: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2706",

          bgColor: "#d6153a",
        },
        6: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2706",

          bgColor: "#d6153a",
        },
        7: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2706",

          bgColor: "#d6153a",
        },
        8: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2706",

          bgColor: "#d6153a",
        },
        9: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2706",

          bgColor: "#d6153a",
        },
        10: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2706",

          bgColor: "#d6153a",
        },
      },
    },
  },

  2: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3432",
    prodName: "Captain Morgan Original Spiced Gold 70cl",
    prodImg: "products/prod-1.png",

    navBgColor: "#1d98d5",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
  },

  3: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3434",

    prodName: "Captain Morgan TIKI 70cl",
    prodImg: "products/prod-2.png",
    navBgColor: "#912b88",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
    carousel: true,
    carouselFull: true,

    hero: {
      video: {
        active: false,
        bgColor: "#58bbd0",
        gradLeft:
          "linear-gradient(90deg, rgba(88,107,208,1) 0%, rgba(88,107,208,0) 100%)",
        gradRight:
          "linear-gradient(-90deg, rgba(88,107,208,1) 0%, rga(88,107,208,0) 100%)",
      },
      bgImg: {
        bgColor: "#439aaf",
        gradLeft:
          "linear-gradient(90deg, rgba(67,154,175,1) 0%, rgba(67,154,175,0) 100%)",
        gradRight:
          "linear-gradient(-90deg, rgba(67,154,175,1) 0%, rgba(67,154,175,0) 100%)",
        maxWidth: "1400px",
      },
      serve_1: true,
      serve_2: true,
    },

    ui: {
      retailers: {
        1: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2703",

          bgColor: "#d6153a",
        },
        2: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2704",
          bgColor: "#d6153a",
        },
        3: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2705",
          bgColor: "#d6153a",
        },
        4: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2706",
          bgColor: "#d6153a",
        },
      },
    },
  },
  4: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3490",
    prodName: "Captain Morgan Original Spiced Gold 1l",
    prodImg: "products/prod-4.png",
    navBgColor: "#912b88",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
    carousel: true,
    carouselFull: true,

    ui: {
      retailers: {
        1: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2703",
          bgColor: "#d6153a",
        },
        2: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2704",
          bgColor: "#d6153a",
        },
        3: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2705",
          bgColor: "#d6153a",
        },
        4: {
          endpoint:
            "https://api.channelsight.com/api/1.47/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=2706",
          bgColor: "#d6153a",
        },
      },
    },
  },
  5: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3491",
    prodName: "Captain Morgan Dark rum 1l",
    prodImg: "products/prod-5.png",
    navBgColor: "#1d98d5",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
  },
  6: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3492",
    prodName: "Captain Morgan Dark rum 70cl",
    prodImg: "products/prod-6.png",
    navBgColor: "#1d98d5",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
  },
  7: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3493",
    prodName: "Captain Morgan white rum 1l",
    prodImg: "products/prod-7.png",
    navBgColor: "#1d98d5",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
  },
  8: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3494",
    prodName: "Captain Morgan white rum 70cl",
    prodImg: "products/prod-8.png",
    navBgColor: "#1d98d5",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
  },
  9: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3495",
    prodName: "Captain Morgan Original spiced gold & cola 250ml",
    prodImg: "products/prod-9.png",
    navBgColor: "#1d98d5",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
  },
  10: {
    apiEndpoint:
      "https://api.channelsight.com/api/2.2/feed?key=b0d332b1-2100-40ad-89e1-c696c042a3c4&assetId=3496",
    prodName: "Captain Morgan Original spiced gold & cola 330ml",
    prodImg: "products/prod-10.png",
    navBgColor: "#1d98d5",
    navLogoSrc: "navbar/logo--white.svg",
    abv: "4.3% ABV",
    active: true,
    classes: "",
    dataProductSku:
      "714015, 757700, 757985, 754815, 754812, 757796, 768099, 757797, 761052, 757645",
    retailers: {},
  },
};

export { dataModel as default };
